import SurveyButton from "./SurveyButton";

/**
 * Back button for the survey.
 *
 * @note This button needs to use the theme from the database, which is structured
 * differently than the theme define in `src/theme.js`.
 * @param {object} props
 * @param {React.MouseEventHandler<HTMLButtonElement> | undefined} props.handleOnClick Handler for the button click event.
 */
function SurveyBackButton({ handleOnClick, forceRounded = false }) {
    return <SurveyButton handleOnClick={handleOnClick} forceRounded={forceRounded}>Back</SurveyButton>;
}

export default SurveyBackButton;
